"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOOTER_CONTENT = void 0;
const FOOTER_CONTENT = exports.FOOTER_CONTENT = 'footer-content';
